import axios from 'axios'
import { AuthModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

const AUTH_LOCAL_STORAGE_KEY = 'tm-panel-token'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = async () => {
  if (!localStorage) return;

  const auth = getAuth();

  // Capture token values before clearing localStorage, so the logout API call
  // can still send the correct Authorization header (the request interceptor on
  // axiosClientAuth reads from localStorage, which would already be empty by then)
  const accessToken = auth?.access_token;
  const refreshToken = auth?.refresh;

  // Remove from localStorage first so the app treats the user as logged out
  // immediately, before the async API call completes
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);

  if (accessToken) {
    try {
      // Use plain axios (not axiosClientAuth) so the request interceptor doesn't
      // try to re-read the token from localStorage (which is already cleared)
      await axios.post(`${API_URL}/auth/logout`, { refresh: refreshToken }, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
    } catch (error) {
      console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
    }
  }
};

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const auth = getAuth()
      if (auth && auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY }